import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Cookies from '../Cookies/Cookies';
import MessengerBubble from '../MessengerBubble/MessengerBubble';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="body-wrapper">
      <Cookies />
      <Header />
      <Breadcrumbs />
      <main>
        {children}
      </main>
      <Footer />
      <MessengerBubble />
    </div>
  );
};

export default Layout;
